import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend({
  primaryKey: 'token',
  keyForRelationship(key) {
    switch (key) {
      case 'managedRoles':
        return 'managed_role_tokens';
      // The employee relationship is tracked by the employee models instead
      case 'employees':
        return null;
      default:
        throw new Error(`Unknown key ${key}`);
    }
  },
  normalizeSingleResponse(store, primaryModelClass, {
    employee_role
  }, id, requestType) {
    return this._super(store, primaryModelClass, employee_role, id, requestType);
  },
  normalizeArrayResponse(store, primaryModelClass, {
    employee_roles
  }, id, requestType) {
    return this._super(store, primaryModelClass, employee_roles, id, requestType);
  }
});